import React from 'react';
import './App.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import routesArr from "./routes";

export default function App() {
  return (
      <BrowserRouter basename="/sc">
          <Routes>
              <Route>
                  {routesArr.map((route, index) => (
                      <Route caseSensitive key={index} index={route.index} path={route.path} element={route.element} />
                  ))}
              </Route>
          </Routes>
      </BrowserRouter>
  );
}
